'use client';

import React, { useState } from 'react';

// ─── AL-KHABIR SECTION ────────────────────────────────────────────────────────
// PDF Pages 19-20 — restored verbatim from source document

export function AlKhabirSection() {
  const [expanded, setExpanded] = useState(false);

  return (
    <section
      id="section-al-khabir-al-zahir"
      style={{
        background: 'rgba(6,13,18,0.97)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 10
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-4xl md:text-5xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Al-Khabir
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                The All-Aware
              </p>
              <p
                style={{
                  fontFamily: "'Amiri', serif",
                  fontSize: 28,
                  color: 'rgba(201,168,76,0.7)',
                  direction: 'rtl',
                }}
              >
                الْخَبِير
              </p>
            </div>
          </div>

          {/* Root Analysis */}
          <div
            className="rounded-xl p-6 mb-8"
            style={{
              background: 'rgba(139,105,20,0.06)',
              border: '1px solid rgba(139,105,20,0.2)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(139,105,20,0.6)' }}
            >
              Root · Kha - Ba - Ra
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                'To know',
                'To be aware of the real inner nature of something',
                'The intrinsic nature of something',
                'To know the reality of something',
                'To prove',
                'Try',
                'Test by experience',
              ].map((m) => (
                <span
                  key={m}
                  className="font-mono text-[10px] px-2 py-1 rounded"
                  style={{
                    background: 'rgba(139,105,20,0.1)',
                    color: 'rgba(212,197,169,0.7)',
                    border: '1px solid rgba(139,105,20,0.15)',
                  }}
                >
                  {m}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Quran 31:34 */}
        <div
          className="rounded-xl p-6 mb-6"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 31:34
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "Indeed, Allah, with Him knowledge the Hour and He sends down the rain and knows
            what in the wombs. And not knows any soul what it will earn tomorrow, and not knows
            any soul in what land it will die. Indeed, Allah Al-Alim; All-Knower, Al-Khabir;
            All-Aware."
          </p>
        </div>

        {/* Quran 6:59,60 */}
        <div
          className="rounded-xl p-6 mb-6"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 6:59,60
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "And with Him keys the unseen, no knows them except Him. And He knows what in the
            land and in the sea. And not falls of any leaf but He knows it. And not a grain in
            the darknesses the earth and not moist and not dry but in a Record Clear. And He
            the One Who takes your by the night and He knows what you committed by the day.
            Then He raises you up therein, so that is fulfilled term specified. Then to Him
            will be your return, then He will inform you about what you used to do."
          </p>
        </div>

        {/* Quran 16:81-83 */}
        <div
          className="rounded-xl p-6 mb-10"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 16:81-83
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "And Allah made for you from what He created, shades, and made for you from the
            mountains, shelters, and made for you garments to protect you the heat and garments
            to protect you from your violence. Thus, He completes His Favor upon you so that
            you may submit. Then, if they turn away, then only upon you the conveyance the
            clear. They recognize the Favor of Allah; then they deny it. And most of them the
            disbelievers/ungrateful ones."
          </p>
        </div>

        {/* Platform Annotation */}
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-full text-left rounded-xl p-5 transition-all"
          style={{
            background: expanded ? 'rgba(201,168,76,0.06)' : 'rgba(255,255,255,0.02)',
            border: `1px solid ${expanded ? 'rgba(201,168,76,0.25)' : 'rgba(255,255,255,0.06)'}`,
          }}
        >
          <div className="flex items-center justify-between">
            <p
              className="font-mono text-[9px] uppercase tracking-widest"
              style={{ color: 'rgba(201,168,76,0.5)' }}
            >
              ◈ Platform Resonance — Al-Khabir in the Garden
            </p>
            <span style={{ color: 'rgba(201,168,76,0.4)', fontSize: 12 }}>
              {expanded ? '▲' : '▼'}
            </span>
          </div>
          {expanded && (
            <div className="mt-4 space-y-3">
              <p
                style={{
                  color: 'rgba(212,197,169,0.65)',
                  fontSize: 13,
                  lineHeight: 1.8,
                }}
              >
                Al-Khabir is the Name that grounds the IRL Lens's deepest layer. "Not a leaf falls but He knows it" — this is the Quranic anchor for the Leaf Sequence. The
                leaf's descent is not random. It is known. Its aerodynamics, its contribution
                to soil health, the organisms that will consume it — all of this is in a Record
                Clear. The IRL Lens reads from that Record. Every observation submitted is a
                recognition of what Al-Khabir already knows.
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.55)',
                  fontSize: 13,
                  lineHeight: 1.8,
                }}
              >
                The root Kha-Ba-Ra includes "to prove, try, test by experience" — this is the
                Haqq Yaqeen principle. Al-Khabir's awareness is not theoretical. It is
                experiential. He knows the intrinsic nature of things through a knowing that
                encompasses every layer — Zahir and Batin, apparent and hidden. The caretaker
                who reaches Haqq Yaqeen is approaching the mode of knowing that Al-Khabir
                embodies: not just information about the thing, but the reality of the thing
                itself.
              </p>
              <div
                className="rounded-lg p-4"
                style={{
                  background: 'rgba(201,168,76,0.05)',
                  border: '1px solid rgba(201,168,76,0.12)',
                }}
              >
                <p
                  className="font-mono text-[8px] uppercase tracking-widest mb-2"
                  style={{ color: 'rgba(201,168,76,0.5)' }}
                >
                  Names Active in This Section
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Al-Khabir', 'Al-Alim', 'Al-Hafiz', 'Al-Baseer', 'Al-Wasi'].map((n) => (
                    <span
                      key={n}
                      className="font-mono text-[9px] px-2 py-1 rounded"
                      style={{
                        background: 'rgba(201,168,76,0.08)',
                        color: '#c9a84c',
                        border: '1px solid rgba(201,168,76,0.15)',
                      }}
                    >
                      {n}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </button>
      </div>
    </section>
  );
}

// ─── AL-ZAHIR SECTION ─────────────────────────────────────────────────────────
// PDF Pages 20-25 — restored verbatim from source document

export function AlZahirSection() {
  const [activeTab, setActiveTab] = useState<'text' | 'three-questions' | 'haals' | 'examination'>('text');

  return (
    <section
      id="section-al-zahir"
      style={{
        background: 'rgba(8,16,24,0.98)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 11
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-4xl md:text-5xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Al-Zahir
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                The Manifest, The Evident
              </p>
              <p
                style={{
                  fontFamily: "'Amiri', serif",
                  fontSize: 28,
                  color: 'rgba(201,168,76,0.7)',
                  direction: 'rtl',
                }}
              >
                الظَّاهِر
              </p>
            </div>
          </div>

          {/* Root Analysis */}
          <div
            className="rounded-xl p-6 mb-8"
            style={{
              background: 'rgba(139,105,20,0.06)',
              border: '1px solid rgba(139,105,20,0.2)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(139,105,20,0.6)' }}
            >
              Root · Za - Ha - Ra
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                'To be visible',
                'Manifest',
                'Obvious',
                'Clear',
                'Distinct',
                'To open',
                'To come out',
                'To cause',
                'To appear after being concealed',
                'To be conspicuous',
                'To ascend',
                'Mount',
                'Have higher status',
                'To have the upper hand',
                'Subdued',
                'Overcome',
                'To endorse',
                'Help',
                'Aid',
                'Support others',
                'Render superior',
              ].map((m) => (
                <span
                  key={m}
                  className="font-mono text-[10px] px-2 py-1 rounded"
                  style={{
                    background: 'rgba(139,105,20,0.1)',
                    color: 'rgba(212,197,169,0.7)',
                    border: '1px solid rgba(139,105,20,0.15)',
                  }}
                >
                  {m}
                </span>
              ))}
            </div>
          </div>

          {/* Quran 57:3 */}
          <div
            className="rounded-xl p-6 mb-8"
            style={{
              background: 'rgba(45,122,71,0.06)',
              border: '1px solid rgba(45,122,71,0.2)',
              borderLeft: '3px solid rgba(45,122,71,0.5)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(45,122,71,0.7)' }}
            >
              Quran 57:3
            </p>
            <p
              style={{
                color: 'rgba(212,197,169,0.8)',
                fontSize: 14,
                lineHeight: 1.85,
                fontStyle: 'italic',
              }}
            >
              "He is The First and The Last, The Manifest, and The Innermost, and He is, of
              all things, knowing."
            </p>
          </div>
        </div>

        {/* Tab Selector */}
        <div className="flex gap-2 mb-8 flex-wrap">
          {[
            { id: 'text', label: 'Zahir / Batin' },
            { id: 'three-questions', label: 'Three Questions' },
            { id: 'haals', label: 'Haals & Wujud' },
            { id: 'examination', label: 'Examination' },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id as typeof activeTab)}
              className="font-mono text-[9px] tracking-widest uppercase px-4 py-2 transition-all"
              style={{
                background:
                  activeTab === t.id ? 'rgba(201,168,76,0.12)' : 'transparent',
                border: `1px solid ${
                  activeTab === t.id
                    ? 'rgba(201,168,76,0.4)'
                    : 'rgba(255,255,255,0.08)'
                }`,
                color:
                  activeTab === t.id ? '#c9a84c' : 'rgba(212,197,169,0.4)',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab: Zahir / Batin */}
        {activeTab === 'text' && (
          <div className="space-y-6" style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}>
            <p>
              The outward, apparent, manifest surface that's evident to the senses is{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>zahir</span>; the
              physical, material, readily observable. Zahir is the perceptible, tangible of
              things, forms, and actions potentially involving{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'basar'</span> — vision.
              In contrast,{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Batin'</span> — inner,
              often hidden, potentially involving{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Basirah'</span> —
              insight, or{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Aql'</span> — intellect.
              Despite not being immediately evident, with applied with effort, thought, and
              reflection. The batin — hidden is accessible and becomes zahir — manifest. Both
              are woven into the tapestry of existence.
            </p>
            <p>
              Every attribute we perceive, hidden and apparent, inner and outer, all originate
              from Allah,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Ahad</span>; The One, The Singularity, the
              uncaused cause. He is{' '}
              <span style={{ color: '#c9a84c' }}>Al-Qawi</span>; The Strong, His strength has
              no limit, no beginning or end; it is not inherited from anything. Whereas we look
              to His creation to understand the attribute of strength via examples. Something
              can be called strong because it exhibits some characteristics we associate with
              the concept of strength. However, while a person can 'build' muscle, all the
              exhibited traits of strength are temporal and contextual. There was a time when
              that strength wasn't present; that strength will pass with time, and the strength
              exhibited has limits; this is true of everything, every state, every attribute,
              every measurement of any thing. All{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'ayat'</span> — signs,
              examples, evidence, proofs in existence.
            </p>
            <p>
              We, a creation entrusted with a degree of consciousness of self and situational
              context, are granted perceptual differentiation; sensory zahir outer, apparent{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Furqan'</span> — means
              to distinguish one thing from another. Eyes facilitate the blessing of vision,
              allowing us to perceive contrast and hue. Skin facilitates touch and ears
              hearing; we were also granted batin, hidden, inner furqan, that which makes
              things clear via insight; hearts to feel and understand, intellect to ponder and
              analyze. We are given the Quran, one of its names is 'The Furqan'.
            </p>

            {/* Quran 35:11 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 35:11
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "And Allah created you from dust, then from a semen-drop; then He made you
                pairs. And not conceives any female and not gives birth except with His
                knowledge. And not is granted life and aged person and not is lessened from his
                life but in a Register. Indeed that for Allah easy."
              </p>
            </div>

            {/* Quran 30:7-10 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 30:7-10
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "They know Zahir, apparent of the life the dunya, world lowest, nearest; but
                they about the Hereafter, they heedless. Do not they ponder within themselves?
                Not Allah created the heavens and the earth and what between them except in
                Haqq, truth/right/reality and a term appointed. And indeed many of the people
                in meeting their Lord surely disbelievers. Have not they traveled in the earth
                and observed how was end those from before them? They were mightier than them
                strength and they dug the earth and built on it more than what they have built
                on it. And then came them their messengers with clear proofs. So not was Allah
                to wrong them but they were themselves doing wrong. Then was end those who did
                evil — the evil, because they denied the Ayat, Signs of Allah and were of them
                making mockery."
              </p>
            </div>

            {/* Quran 16:96,97 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 16:96,97
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "Whatever with you will be exhausted, and whatever with Allah be remaining. And
                surely We will pay those who steadfast, patient their reward to best what they
                used to do. Whoever does righteous deeds whether male or female while he a
                believer, then surely We will give him life, a life good, and We will pay them
                their reward to best of what they used to do."
              </p>
            </div>

            {/* Quran 82:7-12 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 82:7-12
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "Who created you, then fashioned you, then balanced you? In whatever form what
                He willed, He assembled you. Nay! But you deny the Judgment. And indeed, over
                you surely guardians Noble recording, They know whatever you do."
              </p>
            </div>
          </div>
        )}

        {/* Tab: Three Questions */}
        {activeTab === 'three-questions' && (
          <div className="space-y-6">
            <div
              className="space-y-4"
              style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
            >
              <p>
                A few questions can be asked of a thing:{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Is it?'</span>, then:{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'What is it?'</span>;
                the answer to this second question becomes the context of the answer to the
                third question:{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'When is/was it?'</span>{' '}
                The answer to this third question has parts; firstly, anything that exists must
                originate from Allah,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Badi</span>; The Originator's initial
                command 'Be', where time itself became a decree written by the pen at the order
                of Allah,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Qadir</span>; The All-Powerful. Next is
                the regional causality that led to the what-ness of the thing.
              </p>
              <p>
                An apple, therefore, can have the same what-ness as an apple tree, if the
                region of causality extends to encompass its growth on the tree. However, if
                the region of causality is smaller, perhaps from its being harvested to its
                journey en-route to a local market, then at that market, the cultivator
                presents the reasonable label on a sign that names: 'Apple' rather than 'Tree'.
              </p>
            </div>

            {/* Three Questions Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
              {[
                {
                  q: 'Is it?',
                  arabic: 'وُجُود',
                  term: 'Wujud',
                  desc: 'The Is-ness, the haal, state of being real, as well as to find or be aware of, the pure concept of being. As self-aware participants of wujud, we perceive the results of Allah\'s Amr, Command from our created station.',
                  color: '#2d7a47',
                },
                {
                  q: 'What is it?',
                  arabic: 'حُدُوث ذَاتِي',
                  term: 'Huduth Dhati',
                  desc: 'The What-ness, the Essential Nature of a thing, the characteristics that distinguish its intrinsic identity. This collection of manifest attributes enables us to recognize a thing.',
                  color: '#c9a84c',
                },
                {
                  q: 'When is/was it?',
                  arabic: 'حُدُوث زَمَانِي',
                  term: 'Huduth Zamani',
                  desc: 'The Temporal Nature or When-ness of a given creation. Every creation is given some measures that define its being from Allah\'s initial command \'Be\'; creation unfolding along the Huduth-Zamani.',
                  color: '#8a8ab8',
                },
              ].map((item) => (
                <div
                  key={item.q}
                  className="rounded-xl p-5"
                  style={{
                    background: `${item.color}06`,
                    border: `1px solid ${item.color}25`,
                  }}
                >
                  <p
                    className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                    style={{ color: item.color }}
                  >
                    {item.q}
                  </p>
                  <p
                    style={{
                      fontFamily: "'Amiri', serif",
                      fontSize: 18,
                      color: `${item.color}70`,
                      direction: 'rtl',
                      marginBottom: 8,
                    }}
                  >
                    {item.arabic}
                  </p>
                  <p
                    className="font-mono text-[9px] uppercase tracking-widest mb-3"
                    style={{ color: `${item.color}80` }}
                  >
                    {item.term}
                  </p>
                  <p
                    style={{
                      color: 'rgba(212,197,169,0.6)',
                      fontSize: 12,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* Apple / Tree example */}
            <div
              className="rounded-xl p-6 mt-4"
              style={{
                background: 'rgba(45,122,71,0.05)',
                border: '1px solid rgba(45,122,71,0.15)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.6)' }}
              >
                Example — The Apple and the Tree
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.65)',
                  fontSize: 13,
                  lineHeight: 1.8,
                }}
              >
                An apple can have the same what-ness as an apple tree, if the region of
                causality extends to encompass its growth on the tree. However, if the region
                of causality is smaller — from its being harvested to its journey en-route to a
                local market — then at that market, the cultivator presents the reasonable
                label on a sign that names: 'Apple' rather than 'Tree'. The Three Questions
                determine the region of causality. The IRL Lens is a tool for expanding that
                region — from the apple back to the tree, from the tree back to the soil, from
                the soil back to the Decree.
              </p>
            </div>
          </div>
        )}

        {/* Tab: Haals & Wujud */}
        {activeTab === 'haals' && (
          <div className="space-y-6" style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}>
            <p>
              These{' '}
              <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Haals'</span> — states
              of being can correspond to our perception of ayat, signs in creation. Ayat are
              signs, proofs, and evidences composed in the fabric of reality, continually
              unfolding around us. Every perceptible detail of anything, a leaf sliding back
              and forth through a gentle descent to the forest floor, its contribution to soil
              health, the nutrients received through it by the organisms that consume it while
              shaded under the canopy it was once a part of and the aerodynamics of each
              sculpted ridge on the surface of that leaf, all measured.
            </p>
            <p>
              The precise calculation, the apparent order and attributes decreed to every
              zahir, manifest, and every batin, hidden, is evidence of Allah,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Wasi</span>; The All-Encompassing,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Latif</span>; The Subtle,{' '}
              <span style={{ color: '#c9a84c' }}>As-Shaheed</span>; The Witnessed, in the
              Unseen — regardless of how much or little we know the intricacies of the measures
              He Decrees. We can't be All-Knowing, or All-Aware, but we can be guided to
              beneficial knowledge, directed toward fulfilling the trust that we are presented
              in being caretakers placed in the earth.
            </p>

            {/* Wujud / Huduth grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                {
                  term: 'Wujud',
                  arabic: 'وُجُود',
                  desc: 'Refers to the Is-ness, the haal, state of being real, as well as to find or be aware of, the pure concept of being. Our role, observers and participants privy to the ongoing existentiation of reality, serves to acknowledge that every aspect of existence itself is dependent on the Will of Allah.',
                  color: '#2d7a47',
                },
                {
                  term: 'Huduth Dhati',
                  arabic: 'حُدُوث ذَاتِي',
                  desc: 'The What-ness, the Essential Nature of a thing, the characteristics that distinguish its intrinsic identity. Every creation is given some measures that define its being from Allah\'s initial command \'Be\'. Everything is written in The Divine Decree of Al-Alim, Al-Bari, Al-Musawwir, Al-Hakim, Al-Khaliq, Al-Ahad, As-Samad.',
                  color: '#c9a84c',
                },
              ].map((item) => (
                <div
                  key={item.term}
                  className="rounded-xl p-5"
                  style={{
                    background: `${item.color}06`,
                    border: `1px solid ${item.color}20`,
                  }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span
                      className="font-mono text-sm font-black uppercase tracking-widest"
                      style={{ color: item.color }}
                    >
                      {item.term}
                    </span>
                    <span
                      style={{
                        fontFamily: "'Amiri', serif",
                        fontSize: 18,
                        color: `${item.color}60`,
                        direction: 'rtl',
                      }}
                    >
                      {item.arabic}
                    </span>
                  </div>
                  <p
                    style={{
                      color: 'rgba(212,197,169,0.6)',
                      fontSize: 12,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* Birds in flight passage */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(138,138,184,0.05)',
                border: '1px solid rgba(138,138,184,0.15)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(138,138,184,0.6)' }}
              >
                Zahir / Batin — Birds in Flight
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.7)',
                  fontSize: 14,
                  lineHeight: 1.85,
                }}
              >
                Birds in flight, the precision of movement reflects their apparent design. The
                zahir, apparent of its occurrence, can be depicted in a frame-by-frame diagram
                of movements; wings, flapping feathers; the vision we've been granted could be
                sufficient. The intricate measures of the psychology prescribed to them,
                contributions to and purpose within the larger ecosystem, for example, are
                batin — hidden, to many. Much of these unknowns could be revealed with study
                and reflection; understanding sought by pairing{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>basar</span>, eyesight
                with{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>basirah</span>,
                insight. Even though we're just tracing connections that were already there
                with tools we were granted some sense of; we are blessed with the opportunity
                to face, recall, and affirm our conscientious gratitude by striving with
                righteous works.
              </p>
            </div>

            {/* Hadith — Abu Huraira / Sahih Muslim 2749 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(138,138,184,0.06)',
                border: '1px solid rgba(138,138,184,0.2)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(138,138,184,0.6)' }}
              >
                Abu Huraira reported · Sahih Muslim 2749
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.9,
                  fontStyle: 'italic',
                }}
              >
                "The Messenger of Allah, peace and blessings be upon him said, 'By the One in
                Whose Hand is my soul, if you did not sin, Allah would replace you with people
                who would sin and they would seek forgiveness from Allah and He would forgive
                them.'"
              </p>
            </div>

            <p>
              The angels are perfect in their worship as they were created to be; we are a
              different creation. Given choice, guidance, and the opportunity to struggle and
              strive, the opportunity to try our best in whatever circumstances we're granted,
              constantly turning to{' '}
              <span style={{ color: '#c9a84c' }}>Al-Khaliq</span>; The Creator,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Musawwir</span>; The Shaper. This life is
              far shorter than our existence. The work we do here in this brief period sets the
              stage for the rest of that existence. We didn't make the instruments we use to
              set that stage, just the effort we put forth to utilize them. Utilization toward
              goods forms good utensils that facilitate good work; good facilities don't
              generate good, they reflect the good attributes of the One that made the
              instruments, Allah,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Barr</span>; The Source of Goodness,{' '}
              <span style={{ color: '#c9a84c' }}>Al-Mutakabbir</span>; The Greatest.
            </p>
          </div>
        )}

        {/* Tab: Examination */}
        {activeTab === 'examination' && (
          <div className="space-y-6">
            <div
              className="rounded-xl p-4 mb-6"
              style={{
                background: 'rgba(201,168,76,0.04)',
                border: '1px solid rgba(201,168,76,0.15)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest"
                style={{ color: 'rgba(201,168,76,0.5)' }}
              >
                # Examination
              </p>
            </div>

            {/* Quran 67:23-26 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 67:23-26
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "Say. 'He the One Who produced you and made for you the hearing, and the vision
                and the feelings. Little what you give thanks.' Say, 'He the One Who multiplied you in the earth and to Him you will be gathered.' And they say, 'When this
                promise if you are truthful?' Say, 'Only the knowledge with Allah, and only I am a warner clear'"
              </p>
            </div>

            {/* Quran 56:68-81 */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(45,122,71,0.06)',
                border: '1px solid rgba(45,122,71,0.2)',
                borderLeft: '3px solid rgba(45,122,71,0.5)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-3"
                style={{ color: 'rgba(45,122,71,0.7)' }}
              >
                Quran 56:68-81
              </p>
              <p
                style={{
                  color: 'rgba(212,197,169,0.8)',
                  fontSize: 14,
                  lineHeight: 1.85,
                  fontStyle: 'italic',
                }}
              >
                "Do you see the water, which you drink? Is it you who send it down from rain
                clouds, or We the Ones to send? If We willed, We make it salty, then why are
                you not grateful? Do you see the Fire, which you ignite? Is it you who produced
                its tree or We the Producers? We have made it a reminder and a provision for
                wayfarers in the desert. So glorify name your Lord Al-Azim; The Most Great. But
                nay, I swear by the retreat of the stars. And indeed, it surely an oath, if you
                know — great, Indeed it surely a Quran noble, in a book well-guarded, none
                touch it except the purified. A Revelation from Lord the worlds. Then is it to
                this statement that you indifferent?"
              </p>
            </div>

            {/* Examination commentary */}
            <div
              className="space-y-4"
              style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
            >
              <p>
                Examine the Ayah above, of all the provisions we're granted some contexts are
                especially potent reminders. Traveling the desert, of the greatest provision is
                direction. Even if you were granted food and water, with no heading you would
                still be in a difficult situation. The primary waypoints in a map of the desert
                are not its shifting dunes, we look to the stars.
              </p>
              <p>
                In this ayah, the pulling back, retreating of the very stars we only just
                recently realized are indeed fading; as the universe is expanded and each star
                compelled away from the earth, it is evidence, proof, and witness to the
                quality of the more permanent means of guidance we're granted on our journey.
                Direction from the origin,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Awwal</span>; The Very First, The
                Pre-Existing,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Akhir</span>; The End, The Endless —
                from{' '}
                <span style={{ color: '#c9a84c' }}>Al-Hadi</span>; The Guide,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Jabbar</span>; The Compeller, The
                Restorer,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Hafiz</span>; The Preserver,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Haqq</span>; The Absolute Truth, The
                Only Reality.
              </p>
              <p>
                What are the rights of creation? What role am I given, knowing my station as a
                Khalifa, a caretaker in the earth, having received the Amanah, Trust of
                conscious belief and action? Allah, our Creator, tells us that human beings
                weren't created except to worship Him. We are given the example of the rest of
                creation in submission along the Sunna, Way, the System of Allah. Reminded that
                the test of this life is to see who is best in deed, work. Advised to reflect
                on the Ayat, signs present in creation, and the Ayat, words of Allah sent via
                Revelation, to give deep thought, to do as much good as possible, to
                acknowledge and call to the right, the reality. To enjoin good, forbid evil;
                reframing success here.
              </p>
              <p>
                Not to be overly concerned with the fleeting ornamental things of this lower,
                nearest life; instead, recognizing that good deeds are better and more lasting
                in this test. The work itself is about effort, taking the provided means while
                being in a heightened state of{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>Taqwa</span>,
                God-Consciousness in the Deen, Way of life of Islam, Submission. To do so
                while striving toward{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>Ihsan</span>,
                Excellence, in working toward an awareness of Allah as though you can see Him,
                at least to know that He is{' '}
                <span style={{ color: '#c9a84c' }}>Al-Khabir</span>; The All-Aware,{' '}
                <span style={{ color: '#c9a84c' }}>Al-Basir</span>; The All-Seeing.
              </p>
              <p>
                Use granted insights to chart an understanding of the states of creation in
                observed environments. Caretakers transition between projected spaces and
                physical locations;{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>Haals</span>, states
                of being emerge as spaces embedded with ayat linked to the creations within
                them. The quality of these bridges varies based on one's degree of{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Taqwah'</span>{' '}
                (God-Consciousness/Awareness of Allah) in{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>Aml</span>{' '}
                (Work/Deeds). The Highest degree is{' '}
                <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Ihsan'</span> — an
                act/work/deed performed as though you can see Allah, grasping that He is in the
                unseen, to know that He{' '}
                <span style={{ color: '#c9a84c' }}>Al-Baseer</span>; The All-Seeing, sees you.
              </p>
            </div>

            {/* Names Active */}
            <div
              className="rounded-xl p-6"
              style={{
                background: 'rgba(201,168,76,0.05)',
                border: '1px solid rgba(201,168,76,0.15)',
              }}
            >
              <p
                className="font-mono text-[9px] uppercase tracking-widest mb-4"
                style={{ color: 'rgba(201,168,76,0.5)' }}
              >
                Names Active in Al-Zahir Section
              </p>
              <div className="flex flex-wrap gap-2">
                {[
                  'Al-Zahir',
                  'Al-Batin',
                  'Al-Awwal',
                  'Al-Akhir',
                  'Al-Ahad',
                  'Al-Qawi',
                  'Al-Wasi',
                  'Al-Latif',
                  'As-Shaheed',
                  'Al-Hadi',
                  'Al-Jabbar',
                  'Al-Hafiz',
                  'Al-Haqq',
                  'Al-Khabir',
                  'Al-Baseer',
                  'Al-Khaliq',
                  'Al-Musawwir',
                  'Al-Barr',
                  'Al-Mutakabbir',
                  'Al-Badi',
                  'Al-Qadir',
                ].map((n) => (
                  <span
                    key={n}
                    className="font-mono text-[9px] px-2 py-1 rounded"
                    style={{
                      background: 'rgba(201,168,76,0.08)',
                      color: '#c9a84c',
                      border: '1px solid rgba(201,168,76,0.15)',
                    }}
                  >
                    {n}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

// ─── COMBINED EXPORT ──────────────────────────────────────────────────────────

export default function Plot4AlKhabirZahir() {
  return (
    <>
      <AlKhabirSection />
      <AlZahirSection />
    </>
  );
}
